import { CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { homeTranslations } from '../translations/home';

const DifferentiatorsSection = () => {
  const { language } = useLanguage();
  const t = homeTranslations[language].differentiators;

  return (
    <section className="py-24 bg-black relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `repeating-linear-gradient(0deg, transparent, transparent 2px, #B91C1C 2px, #B91C1C 4px),
                           repeating-linear-gradient(90deg, transparent, transparent 2px, #B91C1C 2px, #B91C1C 4px)`
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Title */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              {t.title} <span className="text-[#B91C1C]">{t.titleAccent}</span>
            </h2>
            <div className="w-24 h-1 bg-[#B91C1C]"></div>
            <p className="text-gray-400 mt-6 text-lg leading-relaxed">
              {t.subtitle}
            </p>
          </div>

          {/* Right Side - Benefits List */}
          <div className="space-y-4">
            {t.items.map((item, index) => (
              <div 
                key={index}
                className="flex items-start space-x-4 bg-gray-900/50 border border-gray-800 rounded-lg p-4  backdrop-blur-sm"
                style={{
                  animationDelay: `${index * 100}ms`
                }}
              >
                <div className="flex-shrink-0 mt-1">
                  <CheckCircle2 className="text-[#B91C1C] group-hover:scale-110 transition-transform duration-300" size={24} />
                </div>
                <p className="text-gray-300 text-base leading-relaxed ">
                  {item}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DifferentiatorsSection;
